module.exports = __webpack_public_path__ + "media/images/icon/circle-check-blue-fe312de9020f95ff7dac6dbe862ae180.svg";